import React, {FC} from 'react';
import styled from 'styled-components';

import {emojiToDefinition} from '../../../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {TagHighlightEmojiModel} from '../../../../../models/api/tagModel';
import {baseEmojiValidationMap} from '../../../../../services/emojis/emojis';
import {Emoji} from '../../../../common/emoji/emoji';

/*
 * Props.
 */

interface CellTagEmojiProps {
  tag: TagHighlightEmojiModel;
}

/*
 * Style.
 */

const StyledEmojiTagDiv = styled.div`
  margin-left: 5px;
`;

/*
 * Component.
 */

export const CellTagEmoji: FC<CellTagEmojiProps> = (props) => {
  const definition = emojiToDefinition(props.tag.highlightEmoji, baseEmojiValidationMap);
  if (!definition) {
    return null;
  }

  return (
    <StyledEmojiTagDiv>
      <Emoji {...definition} size={16} />
    </StyledEmojiTagDiv>
  );
};
